<template>
  <v-card flat class="container--fluid">
    <v-card-title class="no-margins">
      <v-text-field
        :value="value"
        clearable
        @click:clear="clearSearch"
        @keydown.enter="emitSearch"
        @change="emitValue"
        prepend-icon="$sl-search"
        placeholder="Sök i listan"
        single-line
        hide-details
        class="simplesearch"
      ></v-text-field>      
    </v-card-title>
    <!-- Label shown whan simple search is active -->
    <v-card flat class="no-margins d-flex justify-end mt-2">
      <a class="mt-2 body-3 none-transformed" v-on:click="$emit('switchMode')">{{ advancedLabel }}</a>
    </v-card>
  </v-card>
</template>

<script>
export default {
  props: {
    // The v-model value
    value: {
      type: String,
    },
    advancedLabel: {
      type: String,
      default: "Avancerad sök och filtrering"
    }
  },
  methods: {
    emitValue (value) {
      // @arg The argument is the value of the selected option
      this.$emit('input', value)
    },
    emitSearch() {
      this.$emit('search')
    },
    clearSearch() {
      this.$emit('input', '')
      this.$emit('search')
    }
  }
}
</script>

<style scoped>
  .simplesearch {
    max-width: 400px;
    min-width: 320px;
  }
</style>